<template lang="pug">
    b-button.mb-0(:type="type", :class="classes", @click="$emit('clicked')")
      div.loader.d-inline-block.mr-1(v-if="flag")
      span {{ label }}
</template>

<script>

export default {
  name: 'loader',
  data() {
    return {
    };
  },
  props: ['label', 'flag', 'type', 'classes'],
  computed: {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.loader {
  border: 2px solid #f7f7f7; border-top: 2px solid #b0b0b0; width: 15px; height: 15px;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/ButtonLoad.vue